export function getWixAdvertisementBannerHeight() {
  return (
    (document?.fullscreenElement &&
      document?.getElementById('WIX_ADS')?.offsetHeight) ||
    0
  );
}

export const setElementToViewport = (element: HTMLElement) => {
  const maximumTopAccordingToWixAdvertisingPanel: number =
    getWixAdvertisementBannerHeight();
  const windowTop: number = element.getBoundingClientRect().top;
  const scrollTop: number = document?.scrollingElement?.scrollTop;

  if (windowTop < maximumTopAccordingToWixAdvertisingPanel && scrollTop) {
    window.scrollTo({
      top: scrollTop - maximumTopAccordingToWixAdvertisingPanel + windowTop,
      left: 0,
    });
  }
};

export const scrollToElement = (qSelector, getLast = false) => {
  const allDOM = document.documentElement.querySelectorAll(qSelector);
  const elementDOM = getLast ? allDOM[allDOM.length - 1] : allDOM[0];

  if (window?.scrollTo && elementDOM) {
    const elementOffsetTop = ((elementDOM.getBoundingClientRect()
      .top as number) + (window.scrollY || window.pageYOffset)) as number;
    const windowHeight = window?.innerHeight ? window.innerHeight - 200 : 600;

    window.scrollTo({
      top: elementOffsetTop - windowHeight + 400,
      left: 0,
      behavior: 'smooth',
    });
  }
};
